import apiURl from '../constant/urls.js';
import {USER_LOGIN,GET_USER_LOGS,GET_USER_SUBSCRIPTION_LOGS,GET_USER_SUBSCRIPTION_DETAIL_LOGS,RESET_USER,EXPORT_ATTENDANCE_REPORT,ENROLL_COURSE} from '../constant/urls.js';
export const Login = async (loginData) => {
    const apiCall = await fetch(`${apiURl}${USER_LOGIN}`,{
        method:'POST',
        headers:{
            'Content-Type':'application/json'
        },
        body:JSON.stringify(loginData)
    });
    const response = await apiCall.json();
    return response;    
};
export const GetUserLogs = async (logsData) => {
    var token = localStorage.getItem('userToken');
    const apiCall = await fetch(`${apiURl}${GET_USER_LOGS}`,{
        method:'POST',
        headers:{
            'Content-Type':'application/json',
            'Authorization':`Bearer ${token}`
        },
        body:JSON.stringify(logsData)
    });
    const response = await apiCall.json();
    return response;    
};
export const GetUserSubscriptionLogs = async (logsData) => {
    var token = localStorage.getItem('userToken');
    const apiCall = await fetch(`${apiURl}${GET_USER_SUBSCRIPTION_LOGS}`,{
        method:'POST',
        headers:{
            'Content-Type':'application/json',
            'Authorization':`Bearer ${token}`
        },
        body:JSON.stringify(logsData)
    });
    const response = await apiCall.json();
    return response;    
};
export const GetUserSubscriptionDetailLogs = async (logsData) => {
    var token = localStorage.getItem('userToken');
    const apiCall = await fetch(`${apiURl}${GET_USER_SUBSCRIPTION_DETAIL_LOGS}`,{
        method:'POST',
        headers:{
            'Content-Type':'application/json',
            'Authorization':`Bearer ${token}`
        },
        body:JSON.stringify(logsData)
    });
    const response = await apiCall.json();
    return response;    
};
export const ResetUserDevices = async (resetData) => {
    var token = localStorage.getItem('userToken');
    const apiCall = await fetch(`${apiURl}${RESET_USER}`,{
        method:'POST',
        headers:{
            'Content-Type':'application/json',
            'Authorization':`Bearer ${token}`
        },
        body:JSON.stringify(resetData)
    });
    const response = await apiCall.json();
    return response;    
};
export const GetUserAttendanceReport = async(queryParams) => {
var token = localStorage.getItem('userToken');
const apiCall = await fetch(`${apiURl}${EXPORT_ATTENDANCE_REPORT}?${queryParams.toString()}`,{
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        }
    });
    return apiCall; 
};
export const EnrollInCourse = async (enrollCourseData) => {
    var token = localStorage.getItem('userToken');
    const apiCall = await fetch(`${apiURl}${ENROLL_COURSE}`,{
        method:'POST',
        headers:{
            'Content-Type':'application/json',
            'Authorization':`Bearer ${token}`
        },
        body:JSON.stringify(enrollCourseData)
    });
    const response = await apiCall.json();
    return response;    
};